module.exports = __webpack_public_path__ + "img/6-5.f89a6435.png";